 
var filterText = (value,length) => { 
  if(!!window.ActiveXObject || "ActiveXObject" in window){
      if (value.length > length) {
        return value.slice(0, length) + "...";
      }
      return value;
    }else{
      return value;
　　 }
}
export default filterText